import React, { useState } from "react";
import { toast } from "sonner";
import { Eraser } from "lucide-react";
import api from "../../api";

export default function AppointmentHistoryCleanup({ onDone }) {
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");

  const run = async (params, label) => {
    if (!window.confirm(`Excluir o histórico de agendamentos de ${label}? Agendamentos futuros confirmados NÃO são apagados.`)) return;
    try {
      const { data } = await api.delete("/admin/appointments/history", { params });
      toast.success(`${data.deleted} agendamento(s) removido(s) do histórico`);
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao excluir"); }
  };

  return (
    <div className="card-arya p-4 mb-4 flex flex-wrap items-end gap-4" data-testid="apt-history-cleanup">
      <div className="flex items-center gap-2 w-full sm:w-auto"><Eraser size={16} className="text-[color:var(--danger)]"/><span className="font-serif text-lg">Excluir histórico</span></div>
      <div className="flex items-end gap-2">
        <input type="date" value={day} onChange={e=>setDay(e.target.value)} className="rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="history-day"/>
        <button disabled={!day} onClick={()=>run({ date: day }, `o dia ${day.split("-").reverse().join("/")}`)} className="btn-ghost !py-2 !px-3 text-xs disabled:opacity-40" data-testid="btn-history-day">Excluir dia</button>
      </div>
      <div className="flex items-end gap-2">
        <input type="month" value={month} onChange={e=>setMonth(e.target.value)} className="rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="history-month"/>
        <button disabled={!month} onClick={()=>run({ month }, `o mês ${month.split("-").reverse().join("/")}`)} className="btn-ghost !py-2 !px-3 text-xs disabled:opacity-40" data-testid="btn-history-month">Excluir mês</button>
      </div>
    </div>
  );
}
